// components/rate/index.js
import pupBasicBehavior from '../../../behaviors/basic'
import transitionBehavior from '../../../behaviors/transition'
Component({
  /**
   * 组件的属性列表
   */
  properties: {
    transition: String,
    overlayStyle: String,
    zIndex: {
      type: Number,
      value: 100
    },
    overlay: {
      type: Boolean,
      value: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      value: true
    },
    position: {
      type: String,
      value: 'center'
    },
    bottom: { // 只有position为bottom的时候生效
      type: String,
      value: ''
    },
    align: {
      type: String,
      value: 'center'
    },
    showHeader: { // 显示head
      type: Boolean,
      value: false
    },
    headerTitle: { // 标题
      type: String,
      value: ''
    },
    titleFontWeight: { // 字粗
      type: String,
      value: '500'
    },
    headerBorder: { // head有圆角
      type: Boolean,
      value: false
    }
  },
  /**
   * 类似于mixins和traits的组件间代码复用机制
   */
  behaviors: [pupBasicBehavior, transitionBehavior(false)],

  externalClasses: ['custom-class'],

  /**
   * 组件的初始数据
   */
  data: {

  },

  /**
   * 组件的方法列表
   */
  methods: {
    onClickOverlay () {
      this.$emit('click-overlay')

      if (this.data.closeOnClickOverlay) {
        this.$emit('close')
      }
    },
    onClosePopup () {
      console.log('onClosePopup')
      this.$emit('close')
    }
  }
})
